import React from 'react'
import { observer } from 'mobx-react'
import useCurrentLocale from 'support/hooks/use-current-locale'
import { LanguageSwitcher } from 'ui/elements'
import { useTranslation } from '@morningtrain/react-translations'

function LocaleSwitcher ({ tablet = false }) {
  const [locale, setLocale] = useCurrentLocale()

  const daLang = useTranslation('generic.languages.da')
  const enLang = useTranslation('generic.languages.en')

  return (
    <LanguageSwitcher tablet={tablet}>
      {tablet
        ? (
          <div className='text-center mt-2'>
            {locale === 'da' ? daLang : enLang}
          </div>
          )
        : null}
      <select style={tablet ? { marginTop: '-100%' } : {}} value={locale} onChange={e => setLocale(e.target.value)}>
        <option value='da'>{daLang}</option>
        <option value='en'>{enLang}</option>
      </select>
    </LanguageSwitcher>
  )
}

export default observer(LocaleSwitcher)
